import {
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
} from "@mui/material";

const RejectionReasonDialog = (props) => {
  const { showRejectionReason, setShowRejectionReason, reason } = props;

  const onClose = () => {
    setShowRejectionReason(false);
  };

  return (
    <>
      <Dialog
        onClose={onClose}
        aria-labelledby="customized-dialog-title"
        open={showRejectionReason}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle className="text-primary">
          <Typography variant="overline" display="block">
            Reason of rejection
          </Typography>
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <span className="material-icons">close</span>
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          <div style={{ height: "200px" }}>
            <div
              className="elevated rounded p-3"
              style={{
                height: "100%",
                backgroundColor: "#fafafa",
                border: "1px solid #17a2b8",
              }}
            >
              <div className="row">
                <div className="col-lg-12 d-flex flex-wrap">
                  <pre style={{ whiteSpace: "pre-wrap" }}>{reason || ""}</pre>
                </div>
              </div>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default RejectionReasonDialog;
